import {
  FiArrowRight,
  FiTrendingUp,
  FiUser,
} from "react-icons/fi";
import { useNavigate } from "react-router-dom";

export default function TopCustomers({ customers = [] }) {
  const navigate = useNavigate();

  const highestRevenue = Math.max(
    ...customers.map((customer) => Number(customer.revenue || 0)),
    1,
  );

  return (
    <div className="bg-white border border-gray-100 rounded-3xl overflow-hidden">
      <div className="flex items-center justify-between p-6 border-b border-gray-100">
        <div>
          <h2 className="text-xl font-bold">Top Customers</h2>

          <p className="text-sm text-gray-500 mt-1">
            Highest revenue-generating customers today
          </p>
        </div>

        <button
          onClick={() => navigate("/admindashboard/sales/customers")}
          className="flex items-center gap-2 text-primary-700 font-semibold"
        >
          View All
          <FiArrowRight />
        </button>
      </div>

      <div className="divide-y divide-gray-100">
        {customers.length ? (
          customers.map((customer, index) => {
            const revenue = Number(customer.revenue || 0);
            const orders = Number(customer.orders || 0);
            const percentage = Math.min(
              (revenue / highestRevenue) * 100,
              100,
            );

            return (
              <div
                key={customer.customerId}
                className="p-5 hover:bg-gray-50 transition"
              >
                <div className="flex justify-between gap-4">
                  <div className="flex gap-4 min-w-0">
                    <div
                      className={`h-11 w-11 shrink-0 rounded-xl flex items-center justify-center font-bold ${
                        index === 0
                          ? "bg-yellow-100 text-yellow-700"
                          : index === 1
                            ? "bg-gray-200 text-gray-700"
                            : index === 2
                              ? "bg-orange-100 text-orange-700"
                              : "bg-primary-50 text-primary-700"
                      }`}
                    >
                      #{index + 1}
                    </div>

                    <div className="min-w-0">
                      <h4 className="font-semibold truncate">
                        {customer.name}
                      </h4>

                      <p className="text-sm text-gray-500 mt-1">
                        Customer Revenue
                      </p>

                      <div className="flex items-center gap-2 mt-2">
                        <div className="h-7 w-7 rounded-lg bg-primary-50 flex items-center justify-center">
                          <FiUser
                            size={14}
                            className="text-primary-700"
                          />
                        </div>

                        <span className="text-sm text-gray-500">
                          {orders} Order{orders === 1 ? "" : "s"} Today
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="text-right shrink-0">
                    <h3 className="font-bold text-lg">
                      {formatMoney(revenue)}
                    </h3>

                    <div className="flex items-center justify-end gap-1 mt-2 text-green-600 text-sm font-semibold">
                      <FiTrendingUp size={14} />
                      Today
                    </div>
                  </div>
                </div>

                <div className="mt-5">
                  <div className="flex justify-between text-xs text-gray-500 mb-2">
                    <span>Revenue Contribution</span>
                    <span>{formatMoney(revenue)}</span>
                  </div>

                  <div className="h-2 bg-gray-100 rounded-full overflow-hidden">
                    <div
                      className="h-full bg-primary-700 rounded-full"
                      style={{ width: `${percentage}%` }}
                    />
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div className="py-16 text-center text-gray-500">
            No customer sales recorded today.
          </div>
        )}
      </div>

      <div className="bg-gray-50 px-6 py-4 flex justify-between items-center">
        <span className="text-sm text-gray-500">
          Showing top {customers.length} customers today
        </span>

        <button
          onClick={() => navigate("/admindashboard/sales/customers")}
          className="text-primary-700 text-sm font-semibold"
        >
          Customer Analytics
        </button>
      </div>
    </div>
  );
}

function formatMoney(value) {
  return `₹${Number(value || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })}`;
}